export const grey = {
  25: '#f4f7fa',
  50: '#eff4f8',
  100: '#eaeff3',
  200: '#e2e7eb',
  300: '#d4d8dd',
  400: '#afb4b8',
  500: '#8f9599',
  600: '#686d71',
  700: '#555a5e',
  800: '#3a3f43',
  900: '#1f2529',
  A100: '#c7cdd1',
  A200: '#1f2529',
  A400: '#2b3034',
  A700: '#555a5e',
} as const;
